
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IntegradleTitle extends Vue {
    get isHardmode(): boolean {
        return this.$store.state.isHardmode;
    }
}
